import { connect } from 'react-redux';
import withTableSubscription from '../../hoc/withTableSubscription';
import withPageTitle from '../../hoc/withPageTitle';
import { feedColumns } from '../../service/tickercolumns';
import {
    updateIndex,
    newIndices,
    fetchIndices,
    changeIndicesFilters,
    loadingIndices,
} from '../../actions/indices';
import IndicesPage from '../../components/pages/IndicesPage';

const sources = [
    'feed.e24.index.MAIN_INDICES_WORLD',
    'feed.e24.index.MAIN_INDICES_EUROPE',
    'feed.e24.index.MAIN_INDICES_NORDIC',
    'feed.e24.index.MAIN_INDICES_NORWAY',
    'feed.misx.index.INDICES',
];

function mapStateToProps({ indices }) {
    return {
        title: 'Index',
        ...indices,
        sources,
        columns: feedColumns,
    };
}

const mapDispatchToProps = {
    update: updateIndex,
    create: newIndices,
    fetch: fetchIndices,
    changeFilters: changeIndicesFilters,
    loadingIndices,
};

export default connect(mapStateToProps, mapDispatchToProps)(
    withTableSubscription(
        withPageTitle(IndicesPage)
    )
);



/** WEBPACK FOOTER **
 ** /src/shared/containers/pages/IndicesPage.js
 **/